import { Duration } from 'luxon'

export const durationToHuman = (duration: string, language: string) =>
  Duration.fromISO(duration).reconfigure({ locale: language }).toHuman()
